import AppLoadingButton from "@/components/mui/LoadingButton";
import RpIcon from "@/components/RpIcon";
import { KYC_STATUS } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "../css/index.module.less";

export default function KYCStatusBody() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.user);

  const _onSumsubKyc = () => {
    navigate(RouteConstant.KYC_SUMSUB);
  }

  const _transLimit = () => {
    let singleAmount = '';
    if (user!.kycAdvancedCardLimit) {
      singleAmount = `${user!.kycAdvancedCardLimit} USD`;
    } else {
      singleAmount = t('unlimited');
    }
    return `${singleAmount}/${t('single')}`;
  }

  const _cardPurchasedCount = () => {
    return  user?.maxApplyCard ?? t('unlimited');
  }

  if (!user) return null;

  if (user.kycStatus !== KYC_STATUS.KYC_STATUS_APPROVED) {
    return <>
      <Stack direction={'column'} gap={'20px'}>
        <div className={'text-secondary'}>
          {t('get_identity_verified')}
        </div>
        <Stack direction={'row'} gap={'12px'}>
          <RpIcon icon={'id-card'} />
          <p className={'h5'}>{t('government_issued_id')}</p>
        </Stack>
        <Stack direction={'row'} gap={'12px'}>
          <RpIcon icon={'biometrics-face'} />
          <p className={'h5'}>{t('facial_recognition')}</p>
        </Stack>
        {/* <Stack direction={'row'} gap={'12px'}>
          <RpIcon icon={'map'} />
          <p className={'h5'}>{t('address')}</p>
        </Stack> */}
      </Stack>
      <Box className={"fixed-button"}>
        <AppLoadingButton disabled={user.kycStatus==KYC_STATUS.KYC_STATUS_SUBMITTED} fullWidth variant="contained" size="large"  onClick={_onSumsubKyc}>
          {t('get_verified')}
        </AppLoadingButton>
      </Box>
    </>
  }

  return (
    <Stack className={classes['kyc-page-info']} direction={'column'} gap={'16px'}>
      <div className={'text-primary'}>{t('rights_interests')} </div>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <span className={'small'}>{t('transaction_limit')}</span>
        <span className={'little'}>{_transLimit()}</span>
      </Stack>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <span className={'small'}>{t('deposit_withdraw')}</span>
        <span className={'little'}>{t('unlimited')}</span>
      </Stack>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <span className={'small'}>{t('card_purchased_number')}</span>
        <span className={'little'}>{_cardPurchasedCount()}</span>
      </Stack>
    </Stack>
  );
}
